// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".entry[data-v-4546b212]{margin-top:10px}.entry[data-v-4546b212]:first-of-type{margin-top:0}", ""]);
// Exports
module.exports = exports;
